<app-styleguide-specimen [rendering]="rendering" e2eId="styleguide-fieldusage-itemlink">
  <h5>Shared Item Link</h5>
  <!-- Item link fields are returned with their value as the referenced item value. -->
  <ng-container *ngIf="rendering.fields.sharedItemLink">
    <!-- The referenced item's fields can be rendered and edited using normal helper components: -->
    <p>
      Field: <span *scText="rendering.fields.sharedItemLink.fields.textField"></span>
    </p>
  </ng-container>

  <h5>Local Item Link</h5>
  <ng-container *ngIf="rendering.fields.localItemLink">
    <p>
      Field: <span *scText="rendering.fields.localItemLink.fields.textField"></span>
    </p>
  </ng-container>
</app-styleguide-specimen>
